import { Box, Skeleton } from "@mui/material";
import { useTheme } from "@mui/system";
import { ControlPanel } from "@src/pages/componentGroupOverview/ComponentGroupOverviewPage.styles";
import { ArticleHeaderSkeleton } from "@src/pages/componentGroupOverview/components/articleHeader/ArticleHeaderSkeleton";
import { type FunctionComponent } from "react";

export const ComponentGroupOverviewPageSkeleton: FunctionComponent = ({ ...restProps }) => {
    const theme = useTheme();

    return (
        <Box {...restProps} pt={8} mb={5} pl={theme.spacing(4)} pr={theme.spacing(4)}>
            <ArticleHeaderSkeleton />

            <ControlPanel>
                <Skeleton width={215} height={30} />
            </ControlPanel>
        </Box>
    );
};
